import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EmployeeModel } from 'src/app/Models/EmpCareerUser.model';
import { EmployeeCareerProgramService } from './employee-career-program.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ProgramsModel } from './models/programs.model';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { error } from 'jquery';
import { YearAndQuaterDataService } from '../services/yearAndQuaterData.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-employee-career-program',
  templateUrl: './employee-career-program.component.html',
  styleUrls: ['./employee-career-program.component.css']
})
export class EmployeeCareerProgramComponent implements OnInit {
  employeeDetails: EmployeeModel;

  employeeId: number;
  userId: number;
  pageNo: number = 1;
  pageSize: number = 8;
  year: any;
  quarterNo: number = 0;
  searchText: string = '';
  selectedPracticeFilter: number = 0;
  searchSubject: Subject<string> = new Subject<string>();
  searchControl: FormControl = new FormControl('');
  isQuarterDisabled: boolean = false;

  practicesList: any = [];
  departmentsList: any = [];

  yearData: any = ["All"];

  quarterData: any;

  assignedProgarms: any;
  recommendedPrograms: any;
  trendingPrograms: any;
  selectedTab: number;
  selectedTabIndex: number = 0;
  element: any;
  selectedDepartment: any = 0;
  isAssignedPrograms = true;
  recommendedPageNumber: number = 1;
  trendingPageNumber: number = 1;
  showAssignedViewMore = true;
  showRecommendedViewMore = true;
  showTrendingViewMore = true;
  loading: boolean =false;
  trendingCount: number = 0;
  assignCount: number = 0;
  recommendedCount: number = 0;
  showRecommendedCount: boolean = false;
  showTrendingCount: boolean = false;

  filterProgram = [{ name: 'All', id: '' }, { name: 'Completed', id: '2' }, { name: 'In Progress', id: '1' }, { name: 'Not Started', id: '3' }];
  statusId: string = '';
  isTrending: boolean;
  practices: any;
  filteredPractices: any;
  practiceId: number = 0;

  group:string = '';
  subGroup:string = '';
  filterSubGroup : string[];
  isAssignedToMeLoading: boolean = false;
  isRecommendedLoading: boolean = false;
  isTrendingLoading: boolean = false;

  constructor(private route: Router, private service: EmployeeCareerProgramService, private authService: AuthServiceService, private spinner: NgxSpinnerService, private quarterAndYearData: YearAndQuaterDataService, private toastr: ToastrService) {
    // let date = new Date();
    // this.year = 0;
    // this.quarterNo = Math.floor(date.getMonth() / 3) + 1;
    if (window.history.state.Status) {
      this.statusId = window.history.state.Status;
    }
    this.initDebounce();
  }

  ngOnInit(): void {
    this.yearData = this.quarterAndYearData?.yearData;
    this.year = new Date().getFullYear();
    this.quarterData = this.quarterAndYearData?.quarterData;
    this.employeeId = parseInt(localStorage.getItem("Id"))
    this.userId = parseInt(localStorage.getItem('EmpCareerUserID'));
    let date = new Date();
    // this.year = "All";
    this.quarterNo = Math.floor(date.getMonth() / 3) + 1;
    this.loading=true;
    this.spinner.show();
    const storedData = localStorage.getItem('empCareerUserDetails');
    if (storedData) {
      this.employeeDetails = JSON.parse(storedData);
    } else {

    }
    this.practiceId = this.employeeDetails?.practiceId;
    this.selectedTab = window.history.state.activeTab;
    sessionStorage.setItem('currentTab', (this.selectedTab || 0) + '');
    if (this.selectedTab) {
      this.selectedTabIndex = this.selectedTab;
      if (this.selectedTabIndex != 0) {
        this.isAssignedPrograms = false;
      }
      if (this.selectedTabIndex == 2) {
        this.isTrending = true;
        if (!this.trendingPrograms) {
          this.getTrendingPrograms();
        }
      } else if (this.selectedTabIndex == 1) {
        if (!this.recommendedPrograms) {
          this.getRecommendedPrograms();
        }
      }
    }
    this.getDistinctsubGroups()
    this.getAssignedPrograms();
    this.getDepartments();
  }

  getAssignedPrograms() {
    this.pageNo = 1;
    this.assignedProgarms = [];
    var model: ProgramsModel = {
      UserId: this.userId,
      PageNo: this.pageNo,
      PageSize: this.pageSize + 1,
      Year: String(this.year) == 'All' ? 0 : Number(this.year),//this.year,
      QuarterNo: this.quarterNo,
      SearchText: this.searchText,
      departments: Number(this.employeeDetails?.departmentId ?? 0),
      StatusId: this.statusId,
      PracticeId: this.practiceId,
      Group : this.group,
      SubGroup : this.subGroup
    };
    this.isAssignedToMeLoading = true;
    this.loading=true;
    this.spinner.show();
    this.service.getAssignedPrograms(model).subscribe(result => {
      var res = result.programs;
      if (res) {
        if (this.searchText) {
          this.assignCount = res.length;
        }
        if (res.length <= 8) {
          this.showAssignedViewMore = false;
        }
        if (res.length > 8) {
          this.showAssignedViewMore = true;
          model.PageSize = this.pageSize;
          res = res.slice(0, 8);
        }
        if (res.length > 0) {
          this.assignedProgarms = res;
        }
        if (!this.yearData || this.yearData.length <= 1) {
        this.yearData = ["All"];
        result.availableYears.forEach(year => {this.yearData.push(year) });
        }
      }
      this.loading=false;
      this.isAssignedToMeLoading = false;
      this.spinner.hide();
    }, error => {
      this.loading=false;
      this.isAssignedToMeLoading = false;
      this.spinner.hide();
      this.toastr.error("Fetching AssignedPrograms Failed")
    });
  }
  async fetchImageUrl(images: any) {
    const Url = await this.getImage(images.programImage);
    images.url = Url;
  }
  async getImage(fileId: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.service.getFileDownloadLink(fileId).subscribe(
        res => {
          if (res) {
            console.log(res.url);
            resolve(res.url);
          } else {
            reject('URL not found in response');
          }
        },
        err => reject(err)
      );
    });
  }

  getRecommendedPrograms() {
    var model: ProgramsModel = {
      UserId: this.userId,
      PageNo: this.recommendedPageNumber,
      PageSize: this.pageSize + 1,
      Year: typeof this.year === 'number' ? this.year : 0,
      QuarterNo: this.quarterNo,
      SearchText: this.searchText,
      departments: Number(this.employeeDetails?.departmentId ?? 0),
      StatusId: '',
      PracticeId: this.practiceId,
      Group:'',
      SubGroup:''
    };
    this.isRecommendedLoading = true;
    this.loading=true;
    this.spinner.show();
    this.service.getRecommendedPrograms(model).subscribe(res => {
      if (res) {
        this.recommendedCount = res.length > 0 && res[0].recordsCount ? res[0].recordsCount : res.length;
        const recommendedPrograms = res;
        new Promise<void>((resolve) => {
          recommendedPrograms.forEach(images => {
            if(images.programImage){
              this.fetchImageUrl(images);
            }
          });
          resolve();
        }).then(() => {
          this.recommendedPrograms = recommendedPrograms;
          if (res.length <= 8) {
            this.showRecommendedViewMore = false;
          }
          if (res.length > 8) {
            this.showRecommendedViewMore = true;
            model.PageSize = this.pageSize;
            res = res.slice(0, 8);
          }
          if (res.length >= 0) {
            this.recommendedPrograms = Array.from(res);
          }
          this.isRecommendedLoading = false;
      this.spinner.hide();
        })
      }

    }, error => {
      this.loading=false;
      this.isRecommendedLoading = false;
      this.spinner.hide();
      this.toastr.error("Fetching RecommendedPrograms Failed")

    });
  }

  getTrendingPrograms() {
    var model = {
      UserId: this.userId,
      PageNo: this.trendingPageNumber,
      PageSize: this.pageSize + 1,
      Year: typeof this.year === 'number' ? this.year : 0,
      QuarterNo: this.quarterNo,
      SearchText: this.searchText,
      departments: Number(this.employeeDetails?.departmentId ?? 0),
      PracticeId: this.practiceId
    };
    this.isTrendingLoading = true;
    this.loading=true;
    this.spinner.show();
    this.service.getTrendingProgarms(model).subscribe((res: any) => {
      if (res) {
        this.trendingCount = res.length > 0 && res[0].recordsCount ? res[0].recordsCount : res.length;
        if (res.length <= 8) {
          this.showTrendingViewMore = false;
        }
        if (res.length > 8) {
          this.showTrendingViewMore = true;
          model.PageSize = this.pageSize;
          res = res.slice(0, 8);
        }
        if (res.length > 0) {
          this.trendingPrograms = Array.from(res);
          this.trendingCount = res[0].recordsCount
        }
        if (res.length == 0) {
          this.trendingPrograms = [];
          this.trendingCount = 0;
        }
      }
      this.loading=false;
      this.isTrendingLoading = false;
      this.spinner.hide();

    }, error => {
      this.loading=false;
      this.isTrendingLoading = false;
      this.spinner.hide();
      this.toastr.error("Fetching Trending Progarms Failed")

    });
  }

  loadAssignedPrograms() {
    var model: ProgramsModel = {
      UserId: this.userId,
      PageNo: this.pageNo + 1,
      PageSize: this.pageSize,
      Year: String(this.year) == 'All' ? 0 : Number(this.year),//this.year,,
      QuarterNo: this.quarterNo,
      SearchText: this.searchText,
      departments: Number(this.employeeDetails.departmentId ?? 0),
      StatusId: this.statusId,
      PracticeId: this.practiceId,
      Group : this.group,
      SubGroup:this.subGroup
    };
    this.isAssignedToMeLoading = true;
    this.loading=true;
    this.spinner.show();
    this.service.getAssignedPrograms(model).subscribe(res => {
      var res = res.programs;
      if (res) {
        if (res.length <= 8) {
          this.showAssignedViewMore = false;
        }
        if (res.length > 8) {
          this.showAssignedViewMore = true;
        }
        if (res.length > 0) {
          this.pageNo = this.pageNo + 1;
          var x = Array.from(res);
          this.assignedProgarms = Array.from(this.assignedProgarms);
          x.forEach(program => {
            this.assignedProgarms.push(program);
          })
          if(this.assignedProgarms.length<res[0]?.recordsCount){
            this.showAssignedViewMore = true;
          }
        }
      }
      this.loading=false;
      this.isAssignedToMeLoading = false;
      this.spinner.hide();

    }, error => {
      this.loading=false;
      this.isAssignedToMeLoading = false;
      this.spinner.hide();
      this.toastr.error("Fetching Assigned Programs Failed")

    });
  }

  loadRecommendedPrograms() {
    var model: ProgramsModel = {
      UserId: this.userId,
      PageNo: this.recommendedPageNumber + 1,
      PageSize: this.pageSize,
      Year: 0,
      QuarterNo: 0,
      SearchText: this.searchText,
      departments: Number(this.employeeDetails.departmentId ?? 0),
      StatusId: '',
      PracticeId: this.practiceId,
      Group:'',
      SubGroup:'',
    };
    this.isRecommendedLoading = true;
    this.loading=true;
    this.spinner.show();
    this.service.getRecommendedPrograms(model).subscribe(res => {
      if (res) {
        if (res.length < 8) {
          this.showRecommendedViewMore = false;
        }
        if (res.length >= 8) {
          this.showRecommendedViewMore = true;
        }
        if (res.length > 0) {
          res.forEach(images =>{
            if(images.programImage){
              this.fetchImageUrl(images);
            }
          })
          this.recommendedPageNumber = this.recommendedPageNumber + 1;
          var x = Array.from(res);
          this.recommendedPrograms = Array.from(this.recommendedPrograms);
          x.forEach(program => {
            this.recommendedPrograms.push(program);
          });
        }
      }
      this.loading=false;
      this.isRecommendedLoading = false;
      this.spinner.hide();
    }, error => {
      this.loading=false;
      this.isRecommendedLoading = false;
      this.spinner.hide();
      this.toastr.error("Fetching Recommended Programs Failed")

    });
  }

  loadTrendingPrograms() {
    var model = {
      PageNo: this.trendingPageNumber + 1,
      PageSize: this.pageSize,
      Year: typeof this.year === 'number' ? this.year : 0,
      QuarterNo: this.quarterNo,
      SearchText: this.searchText,
      PracticeId: this.practiceId
    };
    this.isTrendingLoading = true;
    this.loading=true;
    this.spinner.show();
    this.service.getTrendingProgarms(model).subscribe((res: any) => {
      if (res) {
        if (res.length < 8) {
          this.showTrendingViewMore = false;
        }
        if (res.length >= 8) {
          this.showTrendingViewMore = true;
        }
        if (res.length > 0) {
          this.trendingPageNumber = this.trendingPageNumber + 1;
          var x = Array.from(res);
          this.trendingPrograms = Array.from(this.trendingPrograms);
          x.forEach(program => {
            this.trendingPrograms.push(program);
          });
        }
      }
      this.loading=false;
      this.isTrendingLoading = false;
      this.spinner.hide();
    }, error => {
      this.loading=false;
      this.isTrendingLoading = false;
      this.spinner.hide();
      this.toastr.error("Fetching TrendingProgarms Failed")

    });

  }

  onDepartmentChange(data: any) {
    this.selectedDepartment = data;
  }

  onYearChange() {
    
   // this.year = String(this.year) == 'All' ? 0 : Number(this.year);
  this.isQuarterDisabled = String(this.year) === 'All';
  if(this.isQuarterDisabled) {
      this.quarterNo =0
    }
    this.statusId = ''
    this.getAssignedPrograms();
  }

  onQuarterChange() {
    this.quarterNo = Number(this.quarterNo);
    this.statusId = ''
    this.getAssignedPrograms();
  }

  initDebounce() {
    this.searchSubject.pipe(
      debounceTime(1000)
    ).subscribe(searchText => {
      this.searchPrograms(searchText);
    });
  }

  onSearchTextChanged(searchText: string) {
    this.showRecommendedCount = false;
    this.showTrendingCount = false;
    this.practiceId = 0;
    this.selectedPracticeFilter = 0;
    this.searchSubject.next(searchText);
    if (this.selectedTab === 2) {
      this.trendingPageNumber = 1;
      this.getTrendingPrograms();
      this.showTrendingCount = false;
      this.showRecommendedCount = false;

    }
    if (this.selectedTab === 1) {
      this.recommendedPageNumber = 1;
      this.getRecommendedPrograms();
      this.showRecommendedCount = false;
      this.showTrendingCount = false;
    }
  }
  clearSearch() {
    if (this.searchText == "") {
      this.practiceId = 1;
      this.showRecommendedCount = false;
      this.showTrendingCount = false;
      this.practiceId = this.filteredPractices[0]?.practiceID || 0;
      this.getAssignedPrograms();
      this.getRecommendedPrograms();
      this.getTrendingPrograms();
      this.getDepartments();
    }
  }

  searchPrograms(searchText: string) {
    let model: ProgramsModel = {
      UserId: this.userId,
      PageNo: 1,
      PageSize: this.pageSize,
      Year: typeof this.year === 'number' ? this.year : 0,
      QuarterNo: this.quarterNo,
      SearchText: searchText,
      departments: Number(this.employeeDetails?.departmentId),
      StatusId: this.statusId,
      PracticeId: this.practiceId,
      Group:this.group,
      SubGroup:this.subGroup,
    };
    this.loading=true;
    this.spinner.show();
    this.service.globalSearch(model).subscribe((responses) => {
      if (responses) {
        if (responses[0]) {
          this.assignCount = responses[0]?.programs[0]?.recordsCount;

          if (responses[0].programs.length <= 8) {
            this.showAssignedViewMore = false;
          }
          if (responses[0].programs.length > 8) {
            this.showAssignedViewMore = true;
          }
          if (responses[0].programs.length >= 0) {
            this.pageNo = 1;
            this.assignedProgarms = Array.from(responses[0].programs);
          }
        }
        if (responses[1]) {
          this.recommendedCount = responses[1][0]?.recordsCount;
          if (responses[1].length < 8) {
            this.showRecommendedViewMore = false;
            this.showRecommendedCount = true;
          }
          if (responses[1].length === 8) {
            this.showRecommendedViewMore = true;
            this.showRecommendedCount = true;
          }
          if (responses[1].length >= 0) {
            this.recommendedPageNumber = 1;
            this.recommendedPrograms = Array.from(responses[1]);
          }
        }
        if (responses[2]) {
          this.trendingCount = responses[2][0]?.recordsCount;
          if (responses[2].length < 8) {
            this.showTrendingViewMore = false;
            this.showTrendingCount = true;

          }
          if (responses[2].length === 8) {
            this.showTrendingViewMore = true;
            this.showTrendingCount = true;
          }
          if (responses[2].length >= 0) {
            this.trendingPageNumber = 1;
            this.trendingPrograms = Array.from(responses[2]);
          }
        }
      }
      if (this.selectedTab === 0 && this.assignedProgarms?.length > 0) {

      }
      if (this.selectedTab === 0 && this.assignedProgarms?.length > 0) {

      }
      else if (this.selectedTab === 1 && this.recommendedPrograms?.length > 0) {

      }
      else if (this.selectedTab === 2 && this.trendingPrograms?.length > 0) {

      }
      else if (this.selectedTab !== 0 && this.assignedProgarms?.length > 0) {
        this.selectedTab = 0;
      }
      else if (this.selectedTab !== 1 && this.recommendedPrograms?.length > 0) {
        this.selectedTab = 1;
      }
      else if (this.selectedTab !== 2 && this.trendingPrograms?.length > 0) {
        this.selectedTab = 2;
      }
    });
    this.loading=false;
    this.spinner.hide();
  }

  goToProgramDetails(program) {
    if (this.isAssignedPrograms && this.selectedTabIndex == 0) {
      this.route.navigateByUrl('Home/employee-career/employee-Career-program/' + program?.programID, { state: { prevUrl: 'Home/employee-career/employee-Career-program' } });
      sessionStorage.setItem('programType', '0');
    } else {
      this.route.navigateByUrl('Home/employee-career/employee-Career-program/' + program?.programID, { state: { prevUrl: 'Home/employee-career/employee-Career-program' } });
      sessionStorage.setItem('programType', '1');
    }
  }

  goToProgramDetail(program) {
    this.route.navigateByUrl('/programs/' + program?.programId, { state: { prevUrl: 'Home/employee-career/employee-Career-program' } });
    sessionStorage.setItem('programType', '1');
  }

  onTabChanged(event) {
    this.selectedTabIndex = event.index;
    sessionStorage.setItem('currentTab', this.selectedTabIndex + '');
    if (event.index == 0) {
      this.isAssignedPrograms = true;
      this.isTrending = false;
    }
    else if (event.index == 2) {
      this.isTrending = true;
      this.isAssignedPrograms = false;
      if (!this.trendingPrograms) {
        this.getTrendingPrograms();
      }
    }
    else {
      this.isAssignedPrograms = false;
      this.isTrending = false;
      if (!this.recommendedPrograms) {
        this.getRecommendedPrograms();
      }
    }
  }

  filterProgramsByStatus() {
    this.getAssignedPrograms();
  }

  clearSearchText() {
    this.searchText = "";
    this.selectedPracticeFilter = 0;
    this.practiceId = 1;
    if (this.selectedTab === 2) {
      this.trendingPageNumber = 1;
      this.getTrendingPrograms();
      this.showTrendingCount = false;
      this.showRecommendedCount = false;
    }
    if (this.selectedTab === 1) {
      this.recommendedPageNumber = 1;
      this.getRecommendedPrograms();
      this.showRecommendedCount = false;
      this.showTrendingCount = false;
    }
    this.recommendedPageNumber = 1;
    this.trendingPageNumber = 1;
    this.getAssignedPrograms();
    this.getRecommendedPrograms();
    this.getTrendingPrograms();
  }
  getDepartments() {
    this.service.getAllPracticesAndDepartments().subscribe((res: any) => {
      this.practices = res;

      this.filteredPractices = this.practices.map((practice) => {
        return {
          practiceID: practice?.practiceID,
          practiceName: practice.practiceName,
          departments: [...practice.departments]
        }
      });
    });
  }

  onPracticeChange() {
    if (this.searchText && this.selectedTab === 2) { // Only clear on trending tab
      this.searchText = "";
    }
    if (this.selectedTab === 2) {
      this.trendingPageNumber = 1;
      this.getTrendingPrograms();
      this.showTrendingCount = false;
      this.showRecommendedCount = false;

    }
    if (this.selectedTab === 1) {
      this.recommendedPageNumber = 1;
      this.getRecommendedPrograms();
      this.showTrendingCount = false;

      this.showRecommendedCount = false;
    }
  }

  getDistinctsubGroups(){
    this.service.getDistinctsubGroups().subscribe((res:string[])=>{
      this.filterSubGroup = res;
    });
  }

}
